var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArea = function SvgArea(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.29198C8.57672 9.04 9.04 8.57672 9.29198 8H14.708C14.96 8.57672 15.4233 9.04 16 9.29198V14.708C15.4233 14.96 14.96 15.4233 14.708 16L9.29198 16C9.04 15.4233 8.57672 14.96 8 14.708V9.29198ZM9.29198 18C8.9062 18.883 8.02516 19.5 7 19.5C5.61929 19.5 4.5 18.3807 4.5 17C4.5 15.9748 5.11705 15.0938 6 14.708V9.29198C5.11705 8.9062 4.5 8.02516 4.5 7C4.5 5.61929 5.61929 4.5 7 4.5C8.02516 4.5 8.9062 5.11705 9.29198 6L14.708 6C15.0938 5.11705 15.9748 4.5 17 4.5C18.3807 4.5 19.5 5.61929 19.5 7C19.5 8.02516 18.883 8.9062 18 9.29198V14.708C18.883 15.0938 19.5 15.9748 19.5 17C19.5 18.3807 18.3807 19.5 17 19.5C15.9748 19.5 15.0938 18.883 14.708 18L9.29198 18Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArea);
export default ForwardRef;